import React from 'react'
import type { ClientLibraryId } from 'types/client-library'
import type { TrackId } from 'types/track'
import Icon from 'components/ui/icon'
import Tooltip from 'components/ui/tooltip'
import LibraryMembershipInfo from './LibraryMembershipInfo'
type Props = {
  libraryId: ClientLibraryId
  trackId: TrackId
}

/**
 * Library membership tooltip component with info icon trigger
 * Displays a tooltip with detailed information about why a track is in a catalog
 * @param libraryId - ID of the client library/catalog
 * @param trackId - ID of the track to analyze
 */
const LibraryMembershipTooltip = ({ libraryId, trackId }: Props) => {
  return (
    <Tooltip
      content={
        <LibraryMembershipInfo libraryId={libraryId} trackId={trackId} />
      }
    >
      <Icon type="info-outline" />
    </Tooltip>
  )
}

export default React.memo<Props>(LibraryMembershipTooltip)
